export const environment = {
	production: false,
	apiUrl: 'https://app-timejob-bto-api-stag-westeurope.azurewebsites.net',
	authority: 'https://accounts.stag.timejob-online.de'
};
